<template>
  <base-section
    v-if="products.length"
    id="related-products"
    space="36"
  >
    <v-container style="max-width: 1160px">
      <base-section-heading
        :title="sectionTitle"
        title-tag="h2"
        :is-uppercase="false"
        :space="6"
      />

      <v-row>
        <v-col
          v-for="product in products"
          :key="product.id"
          cols="12"
          sm="6"
          md="4"
        >
          <product-card
            :src="product.src"
            :title="product.title"
            :desc="product.desc"
            :item-id="product.itemId"
            :clickable="product.clickable"
            height="300"
            width="100%"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  import productsData from '@/data/products.json'
  import ProductCard from '@/components/ProductCard'
  import { loadImage } from '@/utils/imageLoader'

  export default {
    name: 'SectionRelatedProducts',

    components: {
      ProductCard,
    },

    data: () => ({
      products: [],
    }),

    computed: {
      currentItemId() {
        return String(this.$route.params.itemId || '')
      },
      sectionTitle() {
        return this.$i18n.locale.startsWith('zh') ? '相关产品' : 'Related Products'
      },
    },

    watch: {
      '$route.params.itemId'() {
        this.loadRelatedProducts()
      },
      '$i18n.locale'() {
        this.loadRelatedProducts()
      },
    },

    async mounted() {
      await this.loadRelatedProducts()
    },

    methods: {
      translateIfKey(value) {
        if (typeof value !== 'string') return value
        return this.$te(value) ? this.$t(value) : value
      },
      pickRelatedCards(cards) {
        if (!Array.isArray(cards) || !cards.length) {
          return []
        }

        const currentId = this.currentItemId
        const current = cards.find(card => String(card.itemId) === currentId)
        const rest = cards.filter(card => String(card.itemId) !== currentId)

        if (!current) {
          return rest.slice(0, 3)
        }

        const sameCategory = rest.filter(card => card.category === current.category)
        const otherCategory = rest.filter(card => card.category !== current.category)
        return [...sameCategory, ...otherCategory].slice(0, 3)
      },
      async buildCardsFromApi(products) {
        if (!Array.isArray(products) || !products.length) {
          return []
        }

        const cards = []
        for (const product of products) {
          if (!product || product.visible === false || !product.id) continue
          const imgUrl = await loadImage(product.coverImage || require('@/assets/logo/logo.png'))
          cards.push({
            id: product.id,
            title: product.name,
            desc: product.desc || product.summary || '',
            src: imgUrl,
            category: product.category,
            itemId: product.slug || String(product.id),
            clickable: product.clickable !== false,
          })
        }
        return cards
      },
      async buildCardsFromLocal() {
        const items = Array.isArray(productsData?.products) ? productsData.products : []
        const cards = []
        for (const item of items) {
          const imgUrl = await loadImage(item.imgUrl || 'logo/logo.png')
          cards.push({
            id: item.id,
            title: this.translateIfKey(item.title),
            desc: this.translateIfKey(item.desc),
            src: imgUrl,
            category: item.category,
            itemId: item.slug || String(item.id),
            clickable: item.clickable !== false,
          })
        }
        return cards
      },
      async loadRelatedProducts() {
        try {
          const resp = await this.$axios({
            method: 'get',
            url: '/public/products',
            params: { lang: this.$i18n.locale },
          })
          const cards = await this.buildCardsFromApi(resp)
          this.products = this.pickRelatedCards(cards.length ? cards : await this.buildCardsFromLocal())
        } catch {
          this.products = this.pickRelatedCards(await this.buildCardsFromLocal())
        }
      },
    },
  }
</script>
